
import React, { useEffect, useState } from 'react';
import Loader from '../../common/loader/Loader'
import './HelpAndSupport.css'
import { useSelector } from 'react-redux';
import { getAllTIcketList, getMessageApi, ticketStatusApi } from '../../api';
import CommonTicket from '../../common/ticket/CommonTicket';
import { toast } from 'react-toastify';



const AllSuportChat = () => {

  const token = useSelector((state) => state?.user?.user?.token); 
 
  const [loading, setLoading] = useState(false);
  const [allTicketData,setAllTicketData]=useState([])
  // const [searchQuery, setSearchQuery] = useState("");
  const [myTimout,setMyTimeOut]=useState()
  const [change, setChange] = useState(false);
  const [currentPage,setCurrentPage]=useState(1);
  const [totalPages,setTotalPages]=useState(1);


  // const handleSearchChange = (newQuery) => {
  //   setSearchQuery(newQuery);
  // };
  
  const handleTicketClose = () => {
    setChange(!change); 
  };


  const handleAllChat=async(currentPage)=>{
    try {
      let status=""
      if(currentPage===1){
        setLoading(true);
      }
      
      const response = await getAllTIcketList({
        token,
        // searchQuery,
        status ,
        currentPage,
        limit:10
      });
      // setAllTicketData(response?.tickets|| []);
      setAllTicketData((prevTickets) => [...prevTickets, ...response?.tickets]);

      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
     
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }

  useEffect(()=>{
    handleAllChat(currentPage)
  },[currentPage,change])


  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //     clearTimeout(myTimout);
  //     setMyTimeOut(setTimeout(handleAllChat, 500));
  //   }
  // }, [searchQuery]);
 

  const loadMoreTickets = () =>{
      if(currentPage<totalPages){
        setCurrentPage((prevPage) => prevPage + 1);
      }
  }
  const hasMoreTickets = currentPage < totalPages;

  return (

  <>
  {loading ? (
    <Loader variant="ticket" />
  ):(
     <CommonTicket 
       AllTicket={allTicketData}  
       setAllTicketData={setAllTicketData}
      //  onSearchChange={handleSearchChange}   
      //  onTicketClose={handleTicketClose} 
       loadMore={loadMoreTickets}   
       hasMore={hasMoreTickets}
      //  key={currentPage}
     />
  )}
  </>
  );
};

export default AllSuportChat;
